import { jsx as _jsx } from "react/jsx-runtime";
export const withConditionalRenderHOC = (Component, shouldRender) => (function WithConditionalRender(props) {
    return shouldRender(props) ? _jsx(Component, { ...props }) : null;
});
export default withConditionalRenderHOC;
